// extracted by mini-css-extract-plugin
export default {"simpleButton":"App_simpleButton__sWLbC","addInstrumentButton":"App_addInstrumentButton__p7659","partDetailsContainer":"App_partDetailsContainer__Oo5MK"};